export const cn = {
  store: "商店",
  meal: "餐点",
  users: "用户",
  user: "用户",
  layout: "布局",
  analytics: "分析",
  settings: "设置",
  storeDetails: "商店信息",
  advanced: "更多设置",
  name: "名字",
  quantity: "量",
  address: "地址",
  email: "邮件地址",
  phone: "电话",
  galleryForCustomer: "顾客显示广告/图片库",
  customMealCategory: "自定义餐点类别",
  storeType: "商店类型",
  currency: "货币",
  add: "添加",
  print: "打印",
  sessions: "访问",
  orders: "订单",
  customerFacingScreen: "顾客显示",
  cashierView: "收银员显示",
  kitchenView: "厨房显示",
  layoutView: "布局显示",
  history: "订单记录",
  noOrderRecordsExist: "不存在订单记录",
  noSessionRecordsExist: "不存在访问记录",
  updateMenu: "更新菜单",
  updateMenuSuccessfully: "成功更新菜单",
  updateMenuTooltip: "每次修改餐点后点击此处以将最新菜单上传",
  serving: "服务中",
  active: "使用中",
  inactive: "未用",
  amount: "数量",
  total: "总数",
  table: "餐桌",
  payment: "支付",
  changeDue: "找回",
  printReceipt: "打印收据",
  closingBillSentToRevenuQuebec: "{channel} / {count}. 结账单将发送至魁北克税务局，即将打印。",
  temporaryBillSentToRevenuQuebec: "{channel} / {count}. 这是临时账单。收据将在魁北克税务局回复后打印。",
  cancel: "取消",
  complete: "完成",
  edit: "更改",
  delete: "删除",
  update: "更新",
  deleteOrder: "删除订单",
  printOrderSlip: "打印订单",
  printKitchenSlip: "打印厨房纸条",
  latestOrderAt: "最新提交于",
  completedAt: "完成于",
  received: "收到于",
  startEditing: "开始编辑",
  save: "保存",
  addSmallDiningTable: "添加小餐桌",
  addMediumDiningTable: "添加中型餐桌",
  addLargeDiningTable: "添加大餐桌",
  clearAll: "清除",
  undo: "撤消",
  reorder: "重新排序",
  renew: "开台",
  renewSession: "重新开台",
  createNewSession: "添加新台",
  addSession: "添加台",
  createSession: "新开台",
  printSession: "打印二维码",
  takeOrder: "点餐",
  editOrder: "更改餐点订单",
  completeOrder: "完成交易",
  description: "简介",
  ingredients: "配料",
  price: "价格",
  category: "分类",
  createdDate: "创建日期",
  lastUpdated: "最新更改日期",
  lastUpdatedAt: "最新更新于",
  admins: "管理员",
  members: "成员",
  member: "成员",
  admin: "管理员",
  invited: "邀请",
  owner: "所有者",
  adminsTooltip: "只有超级管理员(商店所有者)可以更改其他管理员权限",
  membersTooltip: "成员只可以查看和管理客户的订单。",
  invitedTooltip: "被邀请的成员在接受邀请后将被赋予成员权限",
  invitedPeople: "待接受邀请",
  transferOnwership: "转让所有权",
  removeAdminRole: "撤销管理员权限",
  grantAdminRole: "授予管理员权限",
  invitePeople: "邀请",
  addStore: "添加商店",
  alreadyExists: "已经存在",
  existingInvitationTo: "待邀请邮件",
  emailIsRequired: "必须填写邮件地址",
  nameIsRequired: "必须填写名字",
  priceIsRequired: "必须填写价格",
  invalidEmailAddress: "邮件地址无效",
  fullService: "完整服务",
  limitedService: "有限服务",
  storeTypeDescription:
    "更改商店类型将影响收营员显示订单排列的方式以及订单的完成方式",
  limitedServiceDescription:
    "有限服务的订单管理方式为每一次提交即一个订单(e.g. 饮料店，美食广场摊位）",
  fullServiceDescription:
    "完整服务的订单管理方式为每一个餐桌/访问即一个订单(e.g. 餐厅，咖啡厅）",
  fullServiceExplain:
    "完整服务提供完整的用餐体验，顾客通常在用餐完毕后付款。(e.g. 餐厅，咖啡厅）",
  limitedServiceExplain:
    "有限服务通常会在点餐后或上菜时即可付款。(e.g. 饮料店，美食广场摊位）",
  orderIsEmpty: "已无订单记录",
  completedByKitchen: "厨房已完成",
  changeMealImage: "更换餐点图片",
  uploadMealImage: "上传餐点图片",
  food: "食物",
  drink: "饮料",
  side: "小菜",
  submitted: "提交于",
  confirmDeleteMeal: "确认删除此餐点?",
  confirmRenewSession: "访问仍然有效，确认更新此访问?",
  confirmCompleteOrder: "确认完成此订单?",
  confirmDeleteSession: "确认删除此访问?",
  confirmDeleteImage: "确认删除此图片?",
  storeInvitation: "商店邀请",
  noInvitationFound: "未发现邀请，请通知商店管理员",
  join: "加入",
  joinStore: "加入商店",
  settingUpStore: "创立自己的商店",
  createStore: "创立商店",
  invitation: "商店邀请",
  uploadProfilePicture: "上传头像",
  changeProfilePicture: "更换头像",
  myStores: "我的商店",
  profile: "个人资料",
  accountSettings: "账号设置",
  signOut: "登出",
  deleteStore: "删除商店",
  cloneStore: "复制商店",
  uploadImage: "上传图片",
  temporarySession: "暂时性(访问将在24小时后过期)",
  deleteSessionOnCompletion: "每次订单完成后删除访问",
  autoRenew: "自动更新访问（需先删除访问）",
  limitedServiceSession:
    "为了配合有限服务的操作，访问将不会过期或被删除，更改下方的设置以匹配商店的运营方式",
  noExistingNameFound: "在这里添加访问，然后于",
  ifYouWantLink: "添加餐桌以链接访问至布局显示",
  noOptions: "没有选项",
  addCustomerGallery: "添加图片",
  grantAdminRoleToast: "已被赋予[管理员]权限",
  removeAdminRoleToast: "已被撤销[管理员]权限",
  deleteInvitationToast: "已被移除",
  deleteMemberToast: "已被移除",
  deleteAdminToast: "已被移除",
  transferOnwershipToast: "成功转移商店所有人至",
  sendInvitationToast: "邀请成功发送至",
  switchedStoreToast: "切换至",
  deleteStoreToast: "成功删除",
  recommendItToCustomer: "推荐给顾客",
  emailUs: "电邮询问",
  emailUsShort: "电邮询问",
  signup: "注册",
  login: "登录",
  quitStore: "退出商店",
  switchToStore: "切换到此商店",
  changeLogo: "更换标志",
  uploadLogo: "上传标志",
  emailVerifiedToast: "您的电邮地址已经过验证",
  emailSentToast: "电邮已发送！",
  emailSentToastDescription: "请检查您的邮箱以进行验证",
  emailVerificationErrorToast: "验证邮件已发送",
  emailVerificationFailedToast: "发送验证邮件失败",
  resetPasswordToast: "请查看您的电子邮件以重置密码",
  emailNotExist: "电邮地址不存在",
  failedToUpload: "上传失败",
  saveLayoutToast: "餐桌布局已更新",
  invalidEmailOrPassword: "电邮地址或密码无效",
  failedToLogin: "登录失败",
  verificationEmailSent: "验证您的电子邮件",
  verficiationEmailSentDescription:
    "完成帐户注册前，必须先验证该电子邮件地址属于您。",
  emailAlreadyExist: "电邮地址已经存在",
  successfullyCreateStore: "成功创建商店",
  pleaseSwitchStore: ",请切换到您的新商店。",
  pleaseCreateMeal: ",请继续为您的商店创建餐点。",
  youAreNowMemberOf: "你已加入",
  orderFromTable: "餐桌",
  isCompleted: "已完成",
  addedCategory: "添加分类",
  removedCategory: "删除分类",
  currencyChanged: "货币已更改为",
  successfullyUpdateStore: "成功更新商店",
  storeTypeChanged: "已更改商店类型为",
  layoutNotReady: "未设置餐厅布局...",
  layoutNotReadyDescription: "尚未创建餐厅布局，请先前往布局页面创建",
  createLayout: "创建餐厅布局",
  confirmQuitStore: "确认退出商店？",
  minimumItemQuantity: "点餐数量最小小数值",
  noMoreOrder: "已没有更多记录",
  loadMore: "更多记录",
  id: "ID",
  notifications: "通知",
  noNotificationFound: "未发现任何通知",
  noticeHistory: "通知记录",
  noticePlain: "纯文本",
  noticeHidden: "已隐藏",
  confirm: "确认",
  hide: "隐藏",
  previous: "上一页",
  next: "下一页",
  allowMemberEdit: "让成员更改订单",
  storeCreated: "成功创建商店",
  storeCreatedNotification: "成功创建商店, 请继续为您的商店创建餐点。",
  manageSubscription: "订阅管理",
  billing: "计费",
  currentSubscription: "当前订阅",
  mySubscription: "我的订阅",
  initiateSubscription: "如果您是店主，请先创建商店。",
  selectYourStoreType: "选择您的商店类型",
  configureStoreTypeInfo: "如果您不确定要选择哪个，可以稍后重新配置商店类型。",
  compulsoryItem: "自动添加并无法更改数量",
  compulsory: "为必须选项",
  yes: "是",
  no: "否",
  hiddenFromMenu: "从菜单中隐藏",
  dashboard: "仪表盘",
  addedPaymentMethod: "添加付款方式",
  removedPaymentMethod: "删除付款方式",
  paymentMethod: "付款方式",
  paymentMethods: "付款方式",
  options: "选项",
  summarized: "总结",
  unit: "单位",
  unitPlaceHolder: "单位用于显示(e.g., 克,公斤,碗)",
  totalAmount: "总金额",
  checkout: "提交",
  back: "返回",
  close: "关闭",
  remark: "备注",
  orderSettings: "订单",
  paymentKitchenOrder: "先送餐/先付款",
  paymentFirst: "先付款",
  servedFirst: "先送餐",
  alwaysCompleteAtKitchenView:
    "由于您的商店运行先付款模式,所以请在在每一次交易完成后前往厨房显示中完成每一次订单",
  paymentFirstWarning: "在提供完整服务下选择先付款方式可能会导致错误行为",
  paymentKitchenExplained:
    "选择先付款模式以避免订单在付款后被移除,这将帮助您的员工在付款后任可阅读厨房信息。（例如备餐配料）",
  tableName: "访问/布局餐桌名称",
  storeOperation: "商店运营",
  sessionControl: "访问控制",
  all: "完整",
  simple: "简单",
  sessionControlExplained:
    "使用 [简单] 访问控制后，您将无法在 [收营员显示] 内 [添加新访问]、[删除访问]、[更新访问] 以及 [打印访问] , 所以请在更改为 [简单] 访问控制前设定好所有访问配置。",
  none: "无",
  nearest: "四舍五入",
  up: "向上",
  down: "向下",
  roundingTotal: "订单总额进位",
  roundingItem: "个别餐点价格进位",
  changeTo: "更换至",
  allSessionControl: "完整访问控制",
  simpleSessionControl: "简单访问控制",
  requiredTableName: "要求员工/客户在提交时填写餐桌名(与布局餐桌无关)",
  pleaseInsertTableName: "请填写餐桌名称",
  session: "访问",
  inheritFromStore: "继承商店设置",
  customerScreen: "顾客视角",
  recentOrders: "最近的订单",
  standard: "标准",
  standardMenuControl: "标准菜单模式",
  simpleMenuControl: "简单菜单模式",
  menuControl: "员工点餐模式",
  completePaymentFirstAlert: "此订单未完成付款,请先在[收银员显示]完成付款",
  detail: "详情",
  detailNotExists: "订单详情已不存在",
  addedRemarkShortcut: "添加备注快捷键",
  removedRemarkShortcut: "删除备注快捷键",
  remarkShortcuts: "备注快捷键",
  paymentMethodNameIsRequired: "必须填写付款方式",
  paymentMethodAlreadyExisted: "付款方式已经存在",
  categoryNameIsRequired: "必须填写类别名称",
  categoryAlreadyExisted: "类别已经存在",
  shortcutNameIsRequired: "必须填写快捷键名称",
  shortcutAlreadyExisted: "快捷键已经存在",
  shortcut: "快捷键",
  createOption: "添加选项",
  optionName: "选项名称",
  requireChange: "付款时需计算找钱",
  menuSettings: "菜单",
  paymentSettings: "付款",
  submittingOrder: "正在提交...",
  submittedOrder: "成功提交!",
  addMeal: "添加餐点",
  createdFirstMeal: "成功添加餐点",
  pleaseUpdateMenu:
    "成功创建了第一份餐点，完成所有餐点设置后请点击这里以更新菜单",
  pleaseCreateSession: "请前往[收银员显示]页面创建第一个访问/餐桌",
  storeSetupComplete: "成功添加访问",
  moreStoreConfiguration:
    "点击二维码點餐，或打印二维码让顾客扫码点餐。更多的商店配置，請前往[設置]改動以更符合您的商店操作",
  ok: "知道了",
  features: "功能显示",
  others: "其他",
  kitchen: "厨房显示",
  hasBeen: "已被",
  enabled: "启用",
  disabled: "关闭",
  untickToDisable: "取消勾选以关闭功能",
  printAfterCompletion: "订单完成后打印",
  userDecide: "用户决定",
  alreadyAMember: "已经有账号了吗?",
  sign_up: "注册",
  log_in: "登录",
  password: "密码",
  confirmPassword: "确认密码",
  passwordMustBe6: "密码必须至少6个字符长",
  required: "必须填写",
  passwordUnmatched: "密码不匹配",
  forgotPassword: "忘记密码了?",
  OR: "或",
  signInWithGoogle: "使用谷歌账号登录",
  forgotPasswordInfo: "您将收到一封带有重置链接的电子邮件",
  resetPassword: "重设密码",
  verifyYourEmail: "验证您的电子邮件地址",
  check: "检查",
  toVerify: "以验证您的账户并开始使用",
  ifYouHaveNotReceived: "如果几分钟后您还没有收到邮件,请检查您的垃圾邮件箱",
  resendVerificationEmail: "重新发送验证邮件",
  refresh: "刷新",
  startNow: "开始吧",
  freeUnlimitedUsers: "免费，无限用户",
  etilhubDescription: "加入精简的 POS 提升方案，更有效地经营您的餐饮业务。",
  cloudSmart: "云端|智能",
  pointOfSale: "餐饮管理系统",
  registerForFree: "免费注册",
  qrFoodOrdering: "扫码点餐",
  contactlessOrders: "免接触点餐服务",
  instantAndEasySetup: "简单快速设置",
  adjustableForEveryBusiness: "可针对每种餐饮模式进行调整",
  billingProcessingPrinting: "账单处理及打印",
  orderSlipPrinting: "打印客户订单",
  issueReceipt: "打印收据",
  sessionQRPrinting: "打印点餐二维码",
  instantKitchenView: "即时厨房视图",
  realtimeOrderStatus: "实时订单状态",
  orderQueue: "订单队列",
  ingredientsDisplay: "配料显示",
  customizableFloorPlan: "可制定餐厅平面图",
  restaurantTableLayout: "餐厅餐桌布局",
  realtimeTableStatus: "实时餐桌状态",
  intuitiveInterface: "直观的操作界面",
  moreFeatures: "更多功能",
  comingsoon: "即将推出...",
  noItemExist: "不存在餐点記錄",
  myStore: "我的商店",
  logout: "登出",
  navigationSettings: "导航设置",
  navigateToPaymentAfterSubmit: "订单提交后导航至付款 (收银员员显示)",
  size: "体积",
  small: "小",
  medium: "中",
  large: "大",
  tableNameMustBeSame:
    "餐桌名称必须与访问名称相同, 可先在这里添加餐桌再前往商店添加访问。",
  confirmDeleteStore: "通过输入商店名字以确认您要删除该商店:",
  deleteThisStore: "删除此商店?",
  deleteStoreWarning: "这样做将永久删除商店，并且无法恢复。",
  pleaseInsertStoreName: "请输入商店名字",
  cloneThisStore: "复制商店",
  cloneStoreInfo: "输入新商店的资料",
  addIngredient: "添加配料",
  orderUpdatedAt: "订单更新于餐桌",
  simpleMenuInfo: "在简单菜单模式下无法在一个订单内选择多个餐点选项",
  fiverr: "Fiverr",
  bySigningUp: "登录或完成注册即表示你同意",
  privacyPolicy: "隐私政策",
  termsAndConditions: "用户协议",
  and: "和",
  storeExceedSubscriptionLimit:
    "商店数量超过订阅限制,升级您的订阅以添加更多商店。",
  someStoreIsNotShowing: "由于您的订阅已到期，某些商店未被显示。",
  currentPeriodStart: "订阅周期开始于",
  currentPeriodEnd: "订阅将更新于",
  planCanceledOn: "订阅将取消于",
  storeQuantity: "商店数量",
  dailyOrder: "每日订单限制",
  perStore: "单个商店",
  createdBy: "创建者",
  completedBy: "完成者",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  sunday: "星期日",
  morePrices: "选项中有其他价格",
  moreIngredients: "选项中有其他配料",
  all_: "全部",
  filter: "过滤",
  expired: "过期",
  updated: "已更新",
  limitTime: "限时",
  limitDay: "限日",
  outOfStock: "已售罄",
  startFrom: "开始于",
  endAt: "结束于",
  hour: "小时",
  hours: "小时",
  default: "默认",
  cloud: "云端",
  printMethod: "打印方式",
  sessionCreated: "创建访问",
  orderCreated: "创建订单",
  event: "事件",
  eventDescription: "选择触发webhooks的事件类型",
  endPointDescription: "输入用以接收 webhooks 的 URL",
  webhookDescription:
    "我们将向此 URL 提交一个 POST 请求, 该请求包含您选择触发的事件的所有数据(JSON 对象)",
  testEndpointUrl: "测试端点 URL",
  failedToPrint: "打印失敗",
  secretKeyDescription:
    "密钥将被用于与 HTTP 负载进行计算HMAC-SHA256哈希值，并包含在名为 X-Hub-Signature 的标头中",
  outGoingWebhooks: "Outgoing Webhooks",
  urlIsRequired: "必须填写URL",
  invalidUrl: "URL无效",
  endpointUrl: "Endpoint URL",
  addWebhook: "添加 Webhook",
  confirmDeleteWebhook: "确认删除 webhook?",
  printButtonClick: "厨房",
  takeOrderforTable: "点单",
  addGuestNumber: "添加客人数量",
  customerScreen: "客户屏幕",
  orderHistory: "订单历史",
  endSession: "关台",
  orderNow: "点单",
  viewMenu: "看菜单",
  adults: "成人",
  kids: "孩子",
  seniors: "老人",
  other: "其他",
  all:"全部",
  leaveWarning:"您确定要离开吗？ 您所做的更改可能不会保存",
  personAtTable: "人正在点餐，桌号",
  bePatient: "请耐心等待。",
  checkMenu: "请查看菜单",
  cloneItem: "克隆商品",
  language: "语言",
  itemPrintName: "打印项名称",
  serviceFee: "服务费",
  salesReport: "销售报告",
  chatPrint: "打印聊天",
  send: "发送",
  openChatPrint: "打开聊天打印",
  deleteCategory: "删除分类",
  deleteCategoryConfirmation: "确定要删除此分类吗？",
  categoryName: "分类名称",
  deleteCategoryWarning: "警告：此操作无法撤销",
  cannotDeleteCategoryWithItems: "无法删除包含商品的分类",
  totalItems: "总商品数",
  itemsInCategory: "分类中的商品",
  pleaseRemoveItemsFirst: "请先移除商品",
  deletionFailed: "删除失败",
  categoryDeleted: "分类已删除",
  categorySuccessfullyDeleted: "分类删除成功",
  errorDeletingCategory: "删除分类时出错",
  anErrorOccurred: "发生了一个错误",
  categoryAll: "全部",
  languageSettings: "语言设置",
  selectLanguagePopupInfo: "请选择您要在启动弹出窗口中显示的语言，但您需要获取系统中上传的每道菜的语言。",
  languagePopupEnabled: "启用语言弹出窗口",
  languageChoiceActive: "语言选择激活",
  selectLanguage: "选择语言",
  languageChoiceUpdated: "语言选择更新为",
  loadingSession: "加载会话...",
  sessionInvalid: "无效网页",
  loadingMenu: "加载菜单...",
  mergeTables: "合并餐桌",
  selectTablesToMerge: "选择要合并的餐桌",
  selectedTables: "已选餐桌",
  primary: "主要",
  active: "使用中",
  cannotRemove: "无法移除",
  primaryTableRequired: "无法移除主餐桌",
  add: "添加",
  applyMerge: "应用合并",
  invalidTables: "无效餐桌",
  noActiveOrders: "没有活动订单",
  enterYourName: "请输入您的姓名",
  continue: "继续",
  othersOrdering: "欢迎加入！",
  nameRequired: "需要姓名",
  pleaseEnterName: "请输入您的姓名以继续",
  error: "错误",
  somethingWentWrong: "出现了问题",
  welcomeBack: "欢迎回来",
  pleaseWait: "请稍等",
  sessionCheckInProgress: "会话检查进行中",
  noSuchTable: "抱歉，没有这个桌子！",
  waitingForStaff: "等待服务员为您开桌...",
  scanQRCodeAgain: "请再次扫描二维码以点餐或访问菜单！",
  bonAppetit: "祝您用餐愉快！",
  modalSelectLanguage: "选择语言",
  sessionNotProvided: "未提供会话",
  noStoreIdProvided: "会话中没有商店ID",
  storeNotConfigured: "找不到商店",
  failedToLoadData: "加载数据失败",
  orderNumber: "订单 #",
  orderCreated: "创建于",
  orderTotal: "订单总计",
  totalWithTaxes: "含税总计",
  customerName: "姓名",
  totalFor: "总计",
  noOrders: "无订单",
  grandTotal: "总金额",
  pastOrders: "历史订单",
  poweredBy: "技术支持",
  closeButton: "关闭",
  thisSelectionIsRequired: "此选择为必填项",
  pleaseSelectAtLeast: "请至少选择",
  maximumSelections: "最多",
  selectionsAllowed: "个选择",
  optionItems: "选项",
  customizeYourOrder: "定制您的订单",
  totalExtra: "额外费用",
  cancelButton: "取消",
  addToCart: "添加到购物车",
  selectExactly: "必须选择恰好",
  singleItem: "项",
  selectRange: "选择",
  rangeTo: "到",
  selectAtLeast: "至少选择",
  selectUpTo: "最多选择",
  selectMultipleOptional: "多选（可选）",
  selectOneRequired: "单选（必选）",
  requiredOption: "必填",
  
  // TableRedirect translations
  invalidStoreId: "无效的商店ID",
  tableRedirectStoreNotFound: "找不到商店",
  tableRedirectError: "出现了问题，请重试。",
  loadingTable: "正在查找您的餐桌...",
  fixedTableQrDisabled: "此商店已禁用固定餐桌二维码。",
  contactStaffForHelp: "请联系工作人员寻求帮助",
  kdsSplittingTab: "分屏",
  kdsGroupingTab: "合并",
  kdsGroupingHelp: "每条规则都有自己的开关。可以只开一个，也可以两个都开。下面的说明会跟着您选的开关变化。",
  kdsGroupingTimeRule: "时间间隔",
  kdsGroupingCountRule: "订单数量",
  kdsGroupingInterval: "间隔（分钟）",
  kdsGroupingStartMinute: "每小时的起始分钟",
  kdsGroupingOrderCount: "每组订单数",
  kdsGroupingSave: "保存合并",
  kdsGroupPageUp: "上一屏菜品",
  kdsGroupPageDown: "下一屏菜品",
  kdsGroupOrders: "{count} 个订单",
  kdsGroupReady: "{count} 个订单已完成",
  kdsGroupConfirmBody: "确定要把这些订单标记为完成吗？",
  kdsPageFlipInterval: "翻页间隔（秒）",
  kdsPageFlipIntervalHelp: "当一张卡片超出屏幕高度时，厨房会在这么多秒后显示下一屏。默认是 5 秒。",
  kdsPageFlipSaved: "翻页间隔已保存",
  kdsPageFlipSaveFailed: "翻页间隔保存失败",
  kdsGroupingTimeOn: "已开启。时间一到，相同的菜会合并。",
  kdsGroupingTimeOff: "已关闭。时间不会合并票据。",
  kdsGroupingCountOn: "已开启。订单数达到后，相同的菜会合并。",
  kdsGroupingCountOff: "已关闭。订单数量不会合并票据。",
  kdsGroupingOffTitle: "两条规则都已关闭",
  kdsGroupingOffBody: "票据保持分开。请打开时间间隔、订单数量，或两个都打开。",
  kdsGroupingTimeOnlyTitle: "时间间隔已开启",
  kdsGroupingTimeOnlyBody: "每 {minutes} 分钟，从每小时的第 {start} 分钟开始，这一时段内到达的菜会合并，无论是 3 单还是 16 单。当前时段还没结束的订单仍各自显示，直到时间到。",
  kdsGroupingCountOnlyTitle: "订单数量已开启",
  kdsGroupingCountOnlyBody: "同一位厨师每满 {count} 单，相同的菜会合并。第 1 到第 {count} 单成为一组，接下来的 {count} 单成为下一组。还没满 {count} 单的订单仍各自显示。",
  kdsGroupingBothTitle: "两条规则都已开启",
  kdsGroupingBothBody: "先达到的条件会结束这一组，然后时间和数量都重新开始。如果 {count} 单在 {minutes} 分钟之内到达，会立刻合并并重新计时。如果先到了 {minutes} 分钟，已经到达的订单会合并，数量重新计算。",
  kdsGroupingTableRule: "规则",
  kdsGroupingTableExample: "示例",
  kdsGroupingTableResult: "厨房看到的结果",
  kdsGroupingTableTimeRule: "只开时间间隔",
  kdsGroupingTableTimeExample: "每 {minutes} 分钟",
  kdsGroupingTableTimeDetail: "这一时段里可以来任意数量的订单，例如 3 单或 16 单。",
  kdsGroupingTableTimeResult: "{minutes} 分钟一到，这一时段里的订单全部合并，不管来了多少单。",
  kdsGroupingTableCountRule: "只开订单数量",
  kdsGroupingTableCountExample: "每 {count} 单",
  kdsGroupingTableCountDetail: "订单持续进来，没有计时器。",
  kdsGroupingTableCountResult: "一满 {count} 单就合并。接下来的 {count} 单成为下一组。不够 {count} 单的仍各自显示，直到凑满。",
  kdsGroupingTableBothRule: "两个都开",
  kdsGroupingTableBothExample: "每 {minutes} 分钟，或每 {count} 单",
  kdsGroupingTableBothDetail: "先达到的条件结束这一组，然后计时和计数都重新开始。",
  kdsGroupingTableBothResult: "如果 {count} 单在 {minutes} 分钟之内到达，会立刻合并并重新计时。如果先到了 {minutes} 分钟，已经到达的订单会合并，数量重新计算。",
};
